import { fetchCookie } from "./cookies";
import { clearAuthData } from "./tokenUtils";

interface CustomFetchOptions extends RequestInit {
  skipAuthRedirect?: boolean;
}

const customFetch = (
  url: string,
  options: CustomFetchOptions = {}
): Promise<Response> => {
  const token = fetchCookie("1Q_SPA");

  const headers = {
    ...options.headers,
  };

  if (token) {
    (headers as any)["Authorization"] = `Bearer ${token}`;
  }

  const { skipAuthRedirect, ...fetchOptions } = options;

  const finalOptions = {
    ...fetchOptions,
    headers,
  };

  return fetch(url, finalOptions).then((response) => {
    if (response.status === 401 && !skipAuthRedirect) {
      clearAuthData();
      const next = `${window.location.pathname}${window.location.search}`;
      if (next && next !== "/" && !next.startsWith("/sign-in") && !next.startsWith("/get-started")) {
        localStorage.setItem("postLoginRedirect", next);
      }
      window.location.href = "/?auth=login";
      return Promise.reject(new Error("Unauthorized - redirecting to login"));
    }
    return response;
  });
};

export default customFetch;
